<template>
  <el-dialog
    title="撤回审核"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose">
    <el-form :model="form" label-width="100px">
      <el-form-item label="小区名称">
        <el-input v-model="form.communityName" disabled></el-input>
      </el-form-item>
      <el-form-item label="商户名称">
        <el-input v-model="form.storeName" disabled></el-input>
      </el-form-item>
      <el-form-item label="撤回原因" required>
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入撤回原因"
          v-model="form.remark">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitRecall">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recallAudit } from '@/api/common/auditEnterCommunityManageApi'

export default {
  name: 'RecallAuditDialog',
  data() {
    return {
      dialogVisible: false,
      form: {
        communityMemberId: '',
        communityName: '',
        storeName: '',
        remark: ''
      }
    }
  },
  methods: {
    open(community) {
      this.form = {
        communityMemberId: community.communityMemberId,
        communityName: community.name,
        storeName: community.storeName,
        remark: ''
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    async submitRecall() {
      if (!this.form.remark) {
        this.$message.error('撤回原因不能为空')
        return
      }
      try {
        await recallAudit(this.form)
        this.$message.success('撤回成功')
        this.$emit('recall-success')
        this.handleClose()
      } catch (error) {
        console.error('撤回失败:', error)
        this.$message.error('撤回失败')
      }
    },
    resetForm() {
      this.form = {
        communityMemberId: '',
        communityName: '',
        storeName: '',
        remark: ''
      }
    }
  }
}
</script>